var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"medium","width":"100%","height":"calc(-56px + 100vh)"},attrs:{"src":"https://underground.ci-demo.devgeomoby.com"}})}
var staticRenderFns = []

export { render, staticRenderFns }